<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('op_33')"
    icon="res-sku"
    :res-name="detailData.name"
    :current-tab="params.windowData.currentTab"
    :tabs="detailTabs"
    :loaded="loaded"
    @tab-change="handleTabChange">
    <template v-slot:actions>
      <actions :options="singleActions" :row="detailData" button-type="link" button-size="small" />
    </template>
    <component :is="params.windowData.currentTab" :res-id="data.id + ''" :data="detailData" :getParams="getParams" :on-manager="onManager" res-type="billing_sku_service" />
  </base-side-page>
</template>

<script>
import SingleActionsMixin from '../mixins/singleActions'
import ColumnsMixin from '../mixins/columns'
import skuSubcategoryManagerList from '../../sku-subcategory-manager/components/List'
import Detail from './Detail'
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import Actions from '@/components/PageList/Actions'

export default {
  name: 'SKUProjectSidePage',
  components: {
    Detail,
    Actions,
    skuSubcategoryManagerList,
  },
  mixins: [SidePageMixin, WindowsMixin, ColumnsMixin, SingleActionsMixin],
  data () {
    return {
      detailTabs: [
        { label: this.$t('compute.text_238'), key: 'detail' },
        { label: this.$t('op_37'), key: 'sku-subcategory-manager-List' },
        { label: this.$t('compute.text_240'), key: 'event-drawer' },
      ],
    }
  },
  computed: {
    getParams () {
      if (this.params.windowData.currentTab === 'sku-subcategory-manager-List') {
        return {
          sku_service_id: this.data.id,
        }
      }
      return null
    },
  },
}
</script>
